import React from "react";
import YesOrNoQuestion from "./subForms/YesOrNoQuestion";
import { useTranslation } from "react-i18next";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

import { CommonLabel, InputAndLabelWrapper, InputRowWrapper } from "../styles";
import CustomSelect from "../inputs/CustomSelect";
import { isGeorgia, YES_NO_VAL } from "./utils";
import TextInputWithLanguageControl from "../inputs/TextInputWithLanguageControl";
import { SingleColumnWrapper } from "../styles";

const MAX_COUNTRIES = 2;

function TaxResidency({ register, countryList = [] }) {
  const { t } = useTranslation();
  const { clearErrors } = useFormContext();
  const { fields, append, remove, replace } = useFieldArray({
    name: "tax_residency_countries",
    defaultValues: [{ countryId: "", taxCode: "" }],
  });

  const isMaxCountry = fields.length >= MAX_COUNTRIES;
  const taxResidencyValue = useWatch({ name: "tax_residency_question" });

  const showOtherCounties = Number(taxResidencyValue) === YES_NO_VAL.yes;
  const taxResidencyCountryList = countryList?.filter(
    (country) => !isGeorgia(country?.value),
  );

  return (
    <>
      <YesOrNoQuestion
        label={t("tax_residency_question")}
        name="tax_residency_question"
        register={register}
        handleChange={(e) => {
          if (Number(e.target.value) === YES_NO_VAL.no) {
            replace([{ countryId: "", taxCode: "" }]);
            clearErrors(["tax_residency_countries"]);
          }
        }}
      />
      {showOtherCounties ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",

            justifyContent: "flex-start",
            alignItems: "flex-start",
            marginBottom: "20px",
            marginTop: "4px",
          }}
        >
          {fields.map((item, idx) => {
            return (
              <InputRowWrapper key={item.id}>
                <SingleColumnWrapper>
                  <InputAndLabelWrapper>
                    <CommonLabel>{t("select_country")}</CommonLabel>
                    <CustomSelect
                      name={`tax_residency_countries.${idx}.countryId`}
                      options={taxResidencyCountryList}
                      rules={{ required: t("required") }}
                    />
                  </InputAndLabelWrapper>

                  <InputAndLabelWrapper
                    style={{
                      marginTop: idx !== fields.length - 1 ?? "8px",
                    }}
                  >
                    <TextInputWithLanguageControl
                      label={t("enter_tax_code")}
                      name={`tax_residency_countries.${idx}.taxCode`}
                      rules={{ required: t("required") }}
                    />
                  </InputAndLabelWrapper>
                </SingleColumnWrapper>
                {isMaxCountry ? (
                  <button
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                    }}
                    onClick={() => remove(idx)}
                  >
                    x
                  </button>
                ) : null}
              </InputRowWrapper>
            );
          })}

          <button
            disabled={isMaxCountry}
            onClick={() => append({ country: "", taxCode: "" })}
          >
            + {t("add_country")}
          </button>
        </div>
      ) : null}
    </>
  );
}

export default TaxResidency;
